import weights from './weights'

export const typographyDefaults = {
  bigMoney: {
    fontSize: 50,
    lineHeight: '4rem',
    weight: weights.medium,
    comment: 'Big money',
  },
  header1: {
    fontSize: 40,
    lineHeight: '3rem',
    weight: weights.bold,
    comment: 'Header 1',
  },
  header2: {
    fontSize: 32,
    lineHeight: '2.5rem',
    weight: weights.medium,
    comment: 'Header 2',
  },
  pageTitle: {
    fontSize: 24,
    lineHeight: '2rem',
    weight: weights.medium,
    comment: 'Page titles',
  },
  secondaryTitle: {
    fontSize: 20,
    lineHeight: '1.75rem',
    weight: weights.medium,
    comment: 'Secondary titles',
  },
  buttonText: {
    fontSize: 18,
    lineHeight: '1.5rem',
    weight: weights.medium,
    comment: 'Button text',
  },
  inputText: {
    fontSize: 18,
    lineHeight: '1.5rem',
    weight: weights.regular,
    comment: 'Input text',
  },
  secondaryLabel: {
    fontSize: 16,
    lineHeight: '1.5rem',
    weight: weights.regular,
    comment: 'Secondary label',
  },
  tertiaryLabel: {
    fontSize: 12,
    lineHeight: '1rem',
    weight: weights.medium,
    comments: 'Tertiary label',
  },
  mainTitle: {
    fontSize: 18,
    lineHeight: '1.5rem',
    weight: weights.medium,
  },
  mainBody: {
    fontSize: 18,
    lineHeight: '1.5rem',
    weight: weights.regular,
  },
  smallTitle: {
    fontSize: 16,
    lineHeight: '1.5rem',
    weight: weights.medium,
    comment: 'Small titles',
  },
  bodyText: {
    fontSize: 16,
    lineHeight: '1.5rem',
    weight: weights.regular,
    comment: 'Most body text',
  },
  error: {
    fontSize: 14,
    lineHeight: '1.25rem',
    weight: weights.regular,
    comment: 'Text field error messages',
  },
  caption: {
    fontSize: 14,
    lineHeight: '1.25rem',
    weight: weights.regular,
    comment: 'Caption text',
  },
  smallLabel: {
    fontSize: 12,
    lineHeight: '1.25rem',
    weight: weights.medium,
    comment: 'ALL-CAPS SMALL LABELS',
  },
  identifier: {
    fontSize: 12,
    lineHeight: '1rem',
    weight: weights.medium,
    comment: 'Identifiers for fields',
  },
} as const

export const pxToRem = (px: number) => `${px / 16}rem`

type TypographyDefaults = keyof typeof typographyDefaults
const getFontStyles = (key: TypographyDefaults) => {
  return `
        font-size: ${pxToRem(typographyDefaults[key].fontSize)};
        font-weight: ${typographyDefaults[key].weight};
        line-height: ${typographyDefaults[key].lineHeight};
    `
}

type SetType = {
  [key in TypographyDefaults]: string
}

const typography = Object.keys(typographyDefaults).reduce((set, key) => {
  set[key as TypographyDefaults] = getFontStyles(key as TypographyDefaults)
  return set
}, {} as SetType)

type Typography = keyof typeof typography
export type ThemeTypography = Record<Typography, string>

export default typography
